import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

export default function Ticket({ ticketData }) {
    const URL_ORIGIN =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_API_URL_DEV
            : process.env.REACT_APP_API_URL;

    const primaryImg = (ticketData.event.event_images || []).find((img) => img.is_primary);

    function buildQrText(ticketData, event) {
        const token = ticketData?.hash ? String(ticketData.hash) : "";
        const eventId = event?.event_id != null ? String(event.event_id) : "";
        const ticketId = ticketData?.id != null ? String(ticketData.id) : "";
        return `MONOTICKET|EV:${eventId}|T:${ticketId}|Q:${token}`;
    }

    return (
        <div className="ticket-container bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden w-full max-w-md mx-auto sm:max-w-lg md:max-w-xl lg:max-w-sm">
            {primaryImg ? (
                <div className="relative w-full h-60 overflow-hidden bg-slate-900">
                    <img
                        src={`${URL_ORIGIN}/image-proxy?id=${primaryImg.id}`}
                        alt={primaryImg.image_name || "Event image"}
                        className="relative w-full h-full object-fill"
                    />

                    <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-black/40" />
                </div>
            ) : null}

            <div className="ticket-header bg-slate-900 text-white px-4 py-6 text-center">
                <h3 className="text-xl font-extrabold tracking-wide">{ticketData.event.event_name}</h3>
                <h2 className="text-sm opacity-90 mt-1">{ticketData.event.event_location}</h2>
                <p className="text-xs opacity-90 mt-2">
                    {moment(ticketData.event.event_date).utcOffset(0, true).format("dddd, D [de] MMMM [del] YYYY")}
                </p>
                <p className="text-xs opacity-90">{moment(ticketData.event.event_date).utcOffset(0, true).format("hh:mm a")}</p>
            </div>

            <div className="relative h-4 bg-white">
                <div className="absolute left-0 top-[25px] -translate-y-1/2 -translate-x-1/2 w-6 h-6 rounded-full bg-[#121212] border border-slate-200" />
                <div className="absolute right-0 top-[25px] -translate-y-1/2 translate-x-1/2 w-6 h-6 rounded-full bg-[#121212] border border-slate-200" />
                <div className="absolute left-4 right-4 top-1/2 -translate-y-1/2 border-t border-dashed border-slate-200" />
            </div>

            <div className="ticket-body p-5 text-black text-center">
                <div className="ticket-info space-y-2">
                    <div className="flex items-center justify-between bg-slate-50 border border-slate-200 rounded-xl px-3 py-2">
                        <span className="text-xs font-bold text-slate-600">CATEGORÍA</span>
                        <span className="text-sm font-extrabold text-slate-900">{ticketData.ticket_type}</span>
                    </div>

                    {ticketData.seat ? (
                        <div className="flex items-center justify-between bg-slate-50 border border-slate-200 rounded-xl px-3 py-2">
                            <span className="text-xs font-bold text-slate-600">ASIENTO</span>
                            <span className="text-sm font-extrabold text-slate-900">{ticketData.seat}</span>
                        </div>
                    ) : null}
                </div>

                <div className="mt-4 bg-white border-2 border-dashed border-slate-200 rounded-2xl p-4 flex flex-col items-center">
                    <div className="text-xs font-semibold text-slate-600 mb-2">Presenta este QR al ingresar</div>
                    <QRCodeCanvas value={`${buildQrText(ticketData, ticketData.event)}`} size={130} />
                </div>
            </div>

            <div className="ticket-footer bg-slate-50 p-4 text-black text-center text-xs break-words border-t border-slate-200">
                <p className="text-slate-600">Ticket ID: {ticketData.hash}</p>
                <div className="flex justify-center pt-3">
                    <img src="/identity/MONOLOGO.png" className="h-7" alt="Monoticket" />
                </div>
            </div>
        </div>
    );
}
